import { render, staticRenderFns } from "./ObjectSelectSearchable.vue?vue&type=template&id=23f54ed6&scoped=true&"
import script from "./ObjectSelectSearchable.vue?vue&type=script&lang=js&"
export * from "./ObjectSelectSearchable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f54ed6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheSelect: require('/web/components/TheSelect.vue').default})
